import { render, staticRenderFns } from "./PizzaItem.vue?vue&type=template&id=e345dba8&scoped=true&"
import script from "./PizzaItem.vue?vue&type=script&lang=js&"
export * from "./PizzaItem.vue?vue&type=script&lang=js&"
import style0 from "./PizzaItem.vue?vue&type=style&index=0&id=e345dba8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e345dba8",
  null
  
)

export default component.exports